// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

// ── String ────────────────────────────────────────────────────────
export const capitalize = (str) => {
  if (!str) return '';
  const s = str.toString().toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const capitalizeStr = capitalize; // legacy alias

// ── Class names ───────────────────────────────────────────────────
export const classNames = (...classes) => classes.filter(Boolean).join(' ');

// ── Currency ──────────────────────────────────────────────────────
export const formatINR = (amount) => {
  const n = parseFloat(amount ?? 0);
  return (
    '₹' +
    n.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

// ── Numbers ───────────────────────────────────────────────────────
export const formatCompact = (n) =>
  new Intl.NumberFormat('en-IN', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(n);

// ── Objects ───────────────────────────────────────────────────────
export const omit = (obj, keys) =>
  Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)));

export const pick = (obj, keys) =>
  Object.fromEntries(Object.entries(obj).filter(([k]) => keys.includes(k)));
